import React from 'react';
import { useRecordContext, BooleanField } from 'react-admin';

const NullSafeBooleanField = (props) => {
  const record = useRecordContext();
  const value = record?.[props.source];
  return <BooleanField {...props} record={{ ...record, [props.source]: !!value }} />;
};

export default NullSafeBooleanField;
